import { render } from "./mask.vue?vue&type=template&id=858de16e"
import script from "./mask.vue?vue&type=script&lang=js"
export * from "./mask.vue?vue&type=script&lang=js"

import "./mask.vue?vue&type=style&index=0&id=858de16e&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-sold-detail/_components/mask.vue'],['render',render],['__file',"mask.vue"]])

export default __exports__